import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import {
  useCreateInventoryManager,
  useUpdateInventoryManager
} from "../../../apis";
import {
  getInitialManagerFormValues,
  convertManagerFormDataToUpdateBody
} from "../../../helpers";
import { InventoryManagerForm } from "../../forms";
import { InventoryManagerFormValues } from "../../forms/InventoryManagerForm/InventoryManagerForm.types";
import { InventoryManagerModalProps } from "../components.types";

const INVENTORY_MANAGER_FORM_ID = "inventory-manager-form-id";

const InventoryManagerModal = ({
  isOpen,
  onClose,
  editableManager,
  refetchManagers
}: InventoryManagerModalProps) => {
  const { t } = useTranslation();

  const {
    mutate: mutateCreateInventoryManager,
    isLoading: isCreateInventoryManagerLoading
  } = useCreateInventoryManager({
    onSuccess: () => {
      toast.success(t("Inventory Manager created successfully"));
      onClose();
      refetchManagers();
    }
  });

  const { mutate: mutateUpdateInventoryManager } = useUpdateInventoryManager({
    onSuccess: () => {
      toast.success(t("Inventory Manager updated successfully"));
      onClose();
      refetchManagers();
    }
  });

  const handleFormSubmit = (formData: InventoryManagerFormValues) => {
    if (formData.id) {
      const beforeUpdateFormData = getInitialManagerFormValues(editableManager);
      const body = convertManagerFormDataToUpdateBody(
        beforeUpdateFormData,
        formData
      );
      mutateUpdateInventoryManager(body);
    } else {
      const body = {
        imageId: formData.image?.id ?? null,
        phoneNumber: formData.phoneNumber.replace(/\s/g, ""),
        firstname: formData.firstname,
        lastname: formData.lastname,
        password: formData.password,
        repeatPassword: formData.repeatPassword
      };

      mutateCreateInventoryManager(body);
    }
  };

  return (
    <Modal
      formId={INVENTORY_MANAGER_FORM_ID}
      isOpen={isOpen}
      title={`${editableManager ? t("Edit") : t("New")} ${t("Inventory Manager")}`}
      isLoading={isCreateInventoryManagerLoading}
      okText={editableManager ? t("Save") : t("Create")}
      onClose={onClose}
    >
      <InventoryManagerForm
        formId={INVENTORY_MANAGER_FORM_ID}
        onSubmit={handleFormSubmit}
        defaultValues={getInitialManagerFormValues(editableManager)}
      />
    </Modal>
  );
};

export default InventoryManagerModal;
